module.exports = __webpack_public_path__ + "media/images/applications/call-12ff9c07557890408a88e2243c5bea3c.svg";